import React from 'react';

interface NoteDateProps {
  addDate?: string | Date | null;
}

/**
 * Formats note date with time.
 */
export const NoteDate: React.FC<NoteDateProps> = ({ addDate }) => {
  if (!addDate) return <div></div>;
  
  const dateObj = typeof addDate === 'string' ? new Date(addDate) : addDate;
  const formatted = dateObj.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  
  return <div>{formatted}</div>;
};

/** Syncfusion grid template wrapper */
export const noteDateTemplate = (props: { addDate?: string | Date | null }) => (
  <NoteDate addDate={props.addDate} />
);

export default NoteDate;
